import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Header, LeftComponentsHeader } from '../../../components/navigation/Header/Header.style';
import { Nav } from '../../../components/navigation/Nav/Nav';
import { PageTitle } from '../../../components/navigation/Nav/PageTitle';

export const SettingsHeader = memo(function SettingsHeader() {
    return (
        <Header>
            <LeftComponentsHeader>
                <Nav>
                    <PageTitle>
                        <FormattedMessage id="nav.title.settings" />
                    </PageTitle>
                </Nav>
            </LeftComponentsHeader>
        </Header>
    );
});
